import type { IntegrationRequestFormSchema } from '../../../../models/IntegrationRequest';
import { FormCheckbox, FormTextInput } from '@/components';
import type { Control } from 'react-hook-form';
import FormSection from './FormSection';

interface ContactSectionProps {
  control: Control<IntegrationRequestFormSchema>;
  isApi: boolean;
  disabled: boolean;
}

const ContactSection = ({ control, isApi, disabled }: ContactSectionProps) => (
  <FormSection title='Contacto técnico del cliente'>
    <div className='grid grid-cols-1 md:grid-cols-3 gap-4'>
      <FormTextInput control={control} name='contactName' placeholder='Nombre' required disabled={disabled} />
      <FormTextInput control={control} name='contactEmail' placeholder='Email' required disabled={disabled} />
      <FormTextInput control={control} name='contactPhone' placeholder='Teléfono' disabled={disabled} />
    </div>
    {isApi && (
      <div className='grid grid-cols-1 md:grid-cols-2 gap-4 items-center'>
        <FormTextInput
          control={control}
          name='goLiveDate'
          placeholder='Fecha estimada de salida (AAAA-MM-DD)'
          disabled={disabled}
        />
        <FormCheckbox
          control={control}
          name='hasLegacyOrders'
          placeholder='¿Está integrado en el sistema anterior?'
          disabled={disabled}
        />
      </div>
    )}
  </FormSection>
);

export default ContactSection;
